export default __webpack_public_path__ + "static/Gaby-cf6ded9a93ce69cd8f812c790f1f6197.svg";